"use client";

import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LocalAreaContent() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="local-area-content" className="bg-background py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={`max-w-3xl mx-auto flex flex-col items-center text-center transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6 font-serif tracking-tight">
            Discover Nicosia's Vibrant Neighborhoods
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed mb-8">
            Nicosia, the dynamic capital of Cyprus, offers a unique blend of rich history and contemporary living across its diverse districts. From the enchanting, narrow streets of the historic walled city—brimming with Venetian architecture, artisan shops, and traditional cafes—to the modern, bustling commercial hubs of Strovolos and Engomi, there is a neighborhood to suit every lifestyle. Whether you are drawn to the cultural heartbeat of the old town or prefer the quiet, leafy suburbs ideal for family living, Nicosia provides a fascinating tapestry of local experiences waiting to be explored.
          </p>
          <Button size="lg" className="rounded-full px-8">
            Explore the Area
          </Button>
        </div>
      </div>
    </section>;
}